import { render, staticRenderFns } from "./Schedules.vue?vue&type=template&id=4bbc44f6"
import script from "./Schedules.vue?vue&type=script&lang=ts"
export * from "./Schedules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports